<template>
  <popup v-model="showPopup" title="" :loading="loader.on" width="650px" no-padding hide-footer>
    <div class="auto-shutdown-postpone">
      <div class="auto-shutdown-postpone__column auto-shutdown-postpone__column--padding">
        <div class="auto-shutdown-postpone__column__item">
          <div class="auto-shutdown-postpone__column">
            <div class="auto-shutdown-postpone__column__item">
              <v-icon :size="36" color="warning">mdi-alert-circle-outline</v-icon>
            </div>

            <div class="auto-shutdown-postpone__column__item">
              <h3 class="auto-shutdown-postpone__title">{{ t("willShutdownIn") }}</h3>
            </div>

            <div class="auto-shutdown-postpone__column__item">
              <v-text-field class="auto-shutdown-postpone__input--text-field" :value="timeRemaining" hide-details />
            </div>
          </div>
        </div>

        <div class="auto-shutdown-postpone__column__item auto-shutdown-postpone--max-width">
          <p class="auto-shutdown-postpone__label">
            {{ t("explanation") }}
          </p>
        </div>
      </div>

      <div class="auto-shutdown-postpone__row auto-shutdown-postpone__footer">
        <div class="auto-shutdown-postpone__footer__item">
          <v-btn @click="cancelShutdown" large plain>{{ t("button.removeAutoShutdown") }}</v-btn>
        </div>

        <div class="auto-shutdown-postpone__footer__item">
          <v-btn @click="continueShutdown" large>{{ t("button.dismissNotification") }}</v-btn>
          <v-btn @click="postponeShutdown" color="primary" large>{{ t("button.postpone") }}</v-btn>
        </div>
      </div>
    </div>
  </popup>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api"
import { WorkspaceModule } from "@/store"
import { createTranslationModule } from "@/plugins/i18n"
import Utils from "@/utils/utils"
import Popup from "@/components/popup/PopupRoot.vue"
import Loader from "@/utils/loader"

export default defineComponent({
  name: "PostponeAutoShutdownPopup",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    timeRemaining: {
      type: String,
      required: true
    },
    workspaceId: {
      type: String,
      required: true
    },
    preventingNotifications: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const t = createTranslationModule("WorkspaceEdit.postponePopup")
    const workspaceModule = WorkspaceModule()
    const showPopup = Utils.vModel(props, ctx.emit)
    const loader = Loader()

    const continueShutdown = () => {
      showPopup.value = false
      ctx.emit("continue:shutdown")
    }

    const cancelShutdown = () => {
      loader.run(async () => {
        await workspaceModule.cancelAutoShutdown(props.workspaceId)
        await workspaceModule.getWorkspace(props.workspaceId)
        showPopup.value = false
      })
    }

    const postponeShutdown = () => {
      loader.run(async () => {
        await workspaceModule.postponeAutoShutdown(props.workspaceId)
        await workspaceModule.getWorkspace(props.workspaceId)
        ctx.emit("restart:notifications")
        showPopup.value = false
      })
    }

    return {
      t,
      continueShutdown,
      loader,
      postponeShutdown,
      cancelShutdown,
      showPopup
    }
  },
  components: {
    Popup
  }
})
</script>
